export const USER_IS_NOT_ACTIVE = 'USER_IS_NOT_ACTIVE';
export const USER_NOT_FOUND = 'USER_NOT_FOUND';
export const UNKNOW = 'UNKNOW';

export default {
  USER_IS_NOT_ACTIVE,
  USER_NOT_FOUND,
  UNKNOW
};
